import { render, staticRenderFns } from "./SalesListTable.vue?vue&type=template&id=2f91982e&scoped=true"
import script from "./SalesListTable.vue?vue&type=script&lang=ts"
export * from "./SalesListTable.vue?vue&type=script&lang=ts"
import style0 from "./SalesListTable.vue?vue&type=style&index=0&id=2f91982e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91982e",
  null
  
)

export default component.exports